<template>
    <FieldItem
        :id="id"
        :label="$t(fieldConfig.label)"
    >
        <ElInputNumber
            v-model="fieldValue"
            class="search-preferences--number-input"
            size="small"
            :precision="0"
            :min="0"
            @keypress="isNumber($event)"
            @change="syncChange"
        />
    </FieldItem>
</template>

<script>
import InputNumber from 'element-ui/lib/input-number';
import { FieldItemMixin } from './mixins';
import FieldItem from '../components/FieldItem.vue';

export default {
    components: {
        FieldItem,
        ElInputNumber: InputNumber,
    },
    mixins: [FieldItemMixin],
    inject: ['store'],
    props: {
        fieldName: {
            type: String,
            default: 'gap_open',
        },
    },
};
</script>
